import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IEntityBase} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchDigitalResourcesConceptsThunk: any = createAsyncThunk<IEntityBase[], number[]>(
  `${prefix} fetchDigitalResourcesConcepts`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getDigitalResourcesConcepts();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch digital resource concepts. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
